import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-04e992da"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ProfilePreferences" }
const _hoisted_2 = { class: "ProfilePreferences__Title Profile__h2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("h3", _hoisted_2, _toDisplayString(_ctx.$t('profile.preferences')), 1),
    _createElementVNode("ul", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.profile.preferences, (preference, index) => {
        return (_openBlock(), _createElementBlock("li", {
          key: 'profile-preference-'+index,
          class: "ProfilePreferences__Item"
        }, [
          _createElementVNode("span", null, _toDisplayString(preference), 1)
        ]))
      }), 128))
    ])
  ]))
}